/**
     * @desc 获取最新版本的固件
获取最新版本的固件，如果sku已指定固件版本，这返回指定的固件版本
     */
const URL = "/rantion-device";
import http, { updateResponse } from "@/http";
export type Response = defs.device.ResponseDto<defs.device.FirmwareVersionAppResponseDto>;
export function request(
  params: API.device.firmwareVersion.getLastFirmware.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/firmwareVersion/last`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
